<div class="container">
    <app-new-perfil-contratista *ngIf="!loggedUser.contratista?.firstTime"></app-new-perfil-contratista>
    <app-sidebar-contratista></app-sidebar-contratista>
    <app-main-portal-contratista></app-main-portal-contratista>
  </div>
